import { useMutation, UseMutationOptions } from 'react-query';
import apiClient from 'src/queries/apiClient';
import { responseWrapper } from 'src/queries/helpers';

export function useDeleteTravelCompletion(
  options?: UseMutationOptions<any, Error, { id: string; updateVersionNumber: number }>
) {
  const { mutate: deleteTravelCompletion, isLoading } = useMutation<
    any,
    Error,
    { id: string; updateVersionNumber: number }
  >({
    mutationFn: (payload: { id: string; updateVersionNumber: number }) =>
      responseWrapper(apiClient.deleteTravelCompletion, [payload]),
    ...options,
  });

  return {
    deleteTravelCompletion,
    isLoading,
  };
}
